import {getOwnerDataRepository} from "../Infrastructure/DashboardOwner.repository";

export async function getOwnerDataLogic(id, project_id) {
  return getOwnerDataRepository(id, project_id);
}
